import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PaymentCardSkeleton = ({ count }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            width: "20rem",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            padding: "24px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          <Skeleton width={100} height={24} style={{ marginBottom: "8px" }} />
          <Skeleton width="60%" height={18} style={{ marginBottom: "20px" }} />

          <Skeleton width="40%" height={18} style={{ marginBottom: "6px" }} />
          <Skeleton width={120} height={32} style={{ marginBottom: "24px" }} />

          <div style={{ marginBottom: "12px" }}>
            <Skeleton width="90%" height={18} />
          </div>
          <div style={{ marginBottom: "32px" }}>
            <Skeleton width="80%" height={18} />
          </div>

          <Skeleton width="100%" height={48} borderRadius={8} />
        </div>
      ))}
    </>
  );
};

export default PaymentCardSkeleton;
